var React = require('react');

function VolumeDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 328V184a24 24 0 0 1 24-24h102.06l89-89c15-15 41-4.49 41 17v336c0 21.44-25.94 32-41 17l-89-88.95H24A24 24 0 0 1 0 328z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M305.62 188.57a24.08 24.08 0 0 1 32.61-9.45 87.44 87.44 0 0 1 0 153.75 24 24 0 1 1-23.16-42.06 39.43 39.43 0 0 0 0-69.63 24 24 0 0 1-9.45-32.61z","className":"fa-primary","key":2})]);
}

VolumeDown.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = VolumeDown;

VolumeDown.default = VolumeDown;
